import React, { useState, useEffect } from "react"
import { Row, Col } from "antd"
import { useMediaQuery } from "react-responsive"
import Request from "../../helpers/Request"
import ReviewCard from "../reviews/components/ReviewCard"
import type { Review } from "../reviews/components/ReviewCard"

const FeaturedReviews = () => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })
  const [reviews, setReviews] = useState<Review[]>([])

  useEffect(() => {
    Request("/featured_reviews", "GET")
      .then((response) => {
        setReviews(response.data || [])
      })
      .catch(() => {
        // Nothing to show is better than an empty band above the CTA.
        setReviews([])
      })
  }, [])

  if (reviews.length === 0) return null

  return (
    <section
      className="featured-reviews"
      aria-labelledby="featured-reviews-title"
    >
      {/* Same grid as IntegrationSection (offset 4 + span 19) so this block
          lines up with the rest of the page instead of hanging off to the left. */}
      <Row gutter={{ lg: 16 }}>
        <Col span={24} lg={{ span: 19, offset: 4 }}>
          <div className="featured-reviews-header">
            <h2 className="section-title" id="featured-reviews-title">
              {"Ką apie mus sako klientai"}
            </h2>
            <a className="featured-reviews-link" href="/atsiliepimai">
              {"Visi atsiliepimai"}
            </a>
          </div>

          <Row
            gutter={[16, 16]}
            justify="center"
            data-aos={isMobileScreen ? "" : "fade-up"}
          >
            {reviews.map((review, index) => (
              <Col key={index} xs={24} sm={24} md={12} lg={8} xl={8}>
                <ReviewCard review={review} />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </section>
  )
}

export default FeaturedReviews
